import { AxiosResponse } from "axios";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { toast } from "sonner";
import { groupProductValidation } from "../../../../components/Common/Validations";
import CatchBlockFunction from "../../../../components/hooks/CatchBlockFunction";
import { deleteType, get, patch, post, putType } from "../../../../utils/request";
import { IData } from "../types";
import {
  selectFormData,
  selectOrderBy,
  selectOrderDir,
  selectPageNo,
  selectPageSize,
  selectSearch,
  selectToggleLoading,
} from "./selector";
import { actions } from "./slice";

export function* doCreateRequest(action: { payload: { callback: any } }) {
  yield delay(500);

  const form: IData = yield select(selectFormData);
  const isValid = groupProductValidation(form);
  if (!isValid) {
    return;
  }
  const data = {
    title: form?.title,
    featuredImage: form?.featuredImage,
    allergicImages: form?.allergicImages,
    groupId: form?.groupId,
    status: form?.status,
  };

  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(
      post,
      `admin/group/product/add`,
      data
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action?.payload?.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetListRequest() {
  yield delay(500);

  try {
    const pageNo: number = yield select(selectPageNo);
    const pageSize: number = yield select(selectPageSize);
    const orderBy: string = yield select(selectOrderBy);
    const orderDir: string = yield select(selectOrderDir);
    const search: string = yield select(selectSearch);
    const buttonLoading: boolean = yield select(selectToggleLoading);
    if (!buttonLoading) {
      yield put(actions.setLoading(true));
    }

    const response: AxiosResponse = yield call(
      get,
      `admin/group/product/list?pageNo=${pageNo}&pageSize=${pageSize}${
        search.length > 0 ? "&search=" + search : ""
      }${orderBy.length > 0 ? "&orderBy=" + orderBy : ""}${
        orderDir.length > 0 ? "&orderDirection=" + orderDir : ""
      }`
    );
    yield put(actions.setLoading(false));
    yield put(actions.setToggleLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(
      actions.setTotalRow(
        response.data.data.meta ? response.data.data.meta.total : 0
      )
    );
    yield put(actions.setList(response.data.data.results));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    yield put(actions.setToggleLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetByIdRequest(action: { payload: string }) {
  yield delay(500);

  try {
    yield put(actions.setLoading(true));
    const response: AxiosResponse = yield call(
      get,
      `admin/group/product/get/${
        action.payload !== undefined && action.payload !== null
          ? action.payload
          : ""
      }`
    );
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setDataForm(response.data.data[0]));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doUpdateRequest(action: { payload: { callback: any } }) {
  yield delay(500);

  const form: IData = yield select(selectFormData);
  const isValid = groupProductValidation(form);
  if (!isValid) {
    return;
  }
  const data = {
    title: form?.title,
    featuredImage: form?.featuredImage,
    allergicImages: form?.allergicImages,
    groupId: form?.groupId,
    status: form?.status,
  };
  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(
      putType,
      `admin/group/product/update/${form._id}`,
      data
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action?.payload?.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}

export function* doUpdateStatusRequest(action: {
  payload: { id: string; callback: () => void };
}) {
  yield delay(500);
  try {
    yield put(actions.setButtonLoading(true));
    yield put(actions.setToggleLoading(true));
    const response: AxiosResponse = yield call(
      patch,
      `admin/group/product/status/update/${
        action.payload.id !== undefined && action.payload.id !== null
          ? action.payload.id
          : ""
      }`,
      {}
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action.payload.callback);
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetAllListRequest() {
  yield delay(500);

  try {
    const response: AxiosResponse = yield call(get, `admin/product/all`);
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setAllList(response.data.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* doGetAllGroupProductListRequest(action: { payload: string }) {
  yield delay(500);

  try {
    const response: AxiosResponse = yield call(
      get,
      `admin/group/product/list/by-group/${action.payload}`
    );
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setAllGroupList(response.data.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* doDeleteRequest(action: {
  payload: { id: string; callback: () => void };
}) {
  yield delay(500);
  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(
      deleteType,
      `admin/group/product/delete/${action.payload.id}`
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action?.payload?.callback);
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* GroupProductRepoSaga() {
  yield takeLatest(actions.doCreate, doCreateRequest);
  yield takeLatest(actions.doUpdate, doUpdateRequest);
  yield takeLatest(actions.doGetList, doGetListRequest);
  yield takeLatest(actions.doGetById, doGetByIdRequest);
  yield takeLatest(actions.doUpdateStatus, doUpdateStatusRequest);
  yield takeLatest(actions.doGetAllProductList, doGetAllListRequest);
  yield takeLatest(
    actions.doGetAllGroupProductList,
    doGetAllGroupProductListRequest
  );
   yield takeLatest(actions.doDelete, doDeleteRequest);
}
